import { useQuery } from 'react-query';
import { useApi } from 'hooks/useApi';
import ProjectsAPI from 'services/API/ProjectsAPI';
import type { ProjectSize, Project } from 'types';

export const useProjectSizeInfo = (projectSlug: Project['slug']) => {
  const api = useApi();

  return useQuery(
    ['get-project-size-information', projectSlug],
    async (): Promise<ProjectSize | null> => {
      return api.get<ProjectSize | null>(
        ProjectsAPI.getProjectSizeInformation(projectSlug),
      );
    },
    { refetchOnWindowFocus: false },
  );
};
